export default {
  submitText: '保存',
  emptyBtn: false,
  group: [
    {
      label: '房产信息',
      prop: 'group1',
      column: [
        {
          label: '主键/房产编号',
          prop: 'id',
          display: false,
          rules: [
            {
              required: true,
              message: '请输入主键/房产编号',
              trigger: 'change',
            },
          ],
        },
        // {
        //   label: '上级节点id',
        //   prop: 'parentId',
        //   display: false,
        //   readonly: true,
        //   span: 8,
        // },
        // {
        //   label: '上级节点',
        //   prop: 'parentObjectName',
        //   display: true,
        //   disabled: true,
        //   rules: [
        //     {
        //       required: true,
        //       message: '请选择上级节点',
        //       trigger: 'blur',
        //     },
        //   ],
        //   span: 8,
        // },
        {
          label: '上级节点',
          prop: 'parentId',
          formslot: true,
         
          span: 12,
        },
        {
          label: '上级节点',
          prop: 'parentObjectName',
          display: false,
          span: 12,
        },
        {
          label: '上级属性',
          prop: 'parentObjectTypeName',
          display: true,
          disabled: true,
          span: 8,
        },
        {
          label: '本级属性',
          prop: 'objectType',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=object_type',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [{ required: true, message: '请输入本级属性', trigger: 'change' }],
          span: 8,
        },
        {
          label: '节点编码',
          prop: 'objectCode',
          display: true,
          disabled: true,
          rules: [
            {
              required: true,
              message: '请输入节点编码',
              trigger: 'change',
            },
          ],
          span: 8,
        },
        {
          label: '速记码',
          prop: 'shortCode',
          display: true,
          span: 8,
        },
        {
          label: '房间号',
          prop: 'objectName',
          display: true,
          rules: [
            {
              required: true,
              message: '请输入节点名称',
              trigger: 'change',
            },
          ],
          span: 8,
        },
        {
          label: '排序序号',
          prop: 'indexNum',
          display: true,
          rules: [
            { required: true, message: '请输入排序序号' },
            { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数' },
          ],
          span: 8,
        },
        {
          label: '节点名称',
          prop: 'objectFullName',
          display: true,
          disabled: true,
          span: 24,
        },
        {
          label: '房产地址',
          prop: 'roomName',
          display: true,
          rules: [{ required: true, message: '请输入房产地址' }],
          span: 24,
        },
        {
          label: '建筑面积',
          prop: 'floorage',
          display: true,
          placeholder: '请输入 建筑面积，单位m2',
          rules: [
            {
              pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
              message: '请输入整数10位，小数2位',
            },
          ],
          span: 8,
        },
        {
          label: '使用面积',
          prop: 'usableArea',
          display: true,
          placeholder: '请输入 建筑面积，单位m2',
          rules: [
            {
              pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
              message: '请输入整数10位，小数2位',
            },
          ],
          span: 8,
        },
        {
          label: '户型',
          prop: 'roomLayout',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_layout',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
        {
          label: '阁楼面积',
          prop: 'loftArea',
          display: true,
          placeholder: '请输入 建筑面积，单位m2',
          rules: [
            {
              pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
              message: '请输入整数10位，小数2位',
            },
          ],
          span: 8,
        },
        {
          label: '车位面积',
          prop: 'parkingArea',
          display: true,
          placeholder: '请输入 建筑面积，单位m2',
          rules: [
            {
              pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
              message: '请输入整数10位，小数2位',
            },
          ],
          span: 8,
        },
        {
          label: '加建面积',
          prop: 'additionArea',
          display: true,
          placeholder: '请输入 建筑面积，单位m2',
          rules: [
            {
              pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
              message: '请输入整数10位，小数2位',
            },
          ],
          span: 8,
        },
        {
          label: '房屋状态',
          prop: 'roomStatus',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_status',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
        {
          label: '房屋性质',
          prop: 'useType',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/base/property/getUseTypes?code=use_type&remark=1',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [
            {
              required: true,
              message: '请选择房屋性质',
              trigger: 'blur',
            },
          ],
          span: 8,
        },
        {
          label: '朝向',
          prop: 'roomOrientations',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_orientations',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
        {
          label: '用途',
          prop: 'useDesc',
          display: true,
          span: 16,
        },
        {
          label: '房屋类型',
          prop: 'roomType',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_type',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
      ],
    },
    {
      label: '户主信息',
      prop: 'group2',
      column: [
        {
          label: '户主姓名',
          prop: 'householdName',
          display: true,
          rules: [{ required: true, message: '请输入户主姓名' }],
          span: 8,
        },
        {
          label: '性别',
          prop: 'householdSex',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=sex',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
        {
          label: '联系电话',
          prop: 'householdLinkPhone',
          display: true,
          rules: [{ pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '请输入正确手机号码' }],
          span: 8,
        },
        {
          label: '身份证',
          prop: 'householdIdCard',
          display: true,
          span: 8,
        },
        {
          label: '邮箱',
          prop: 'householdEmail',
          display: true,
          span: 8,
        },
        {
          label: 'QQ',
          prop: 'householdQQ',
          display: true,
          span: 8,
        },
        /*{
          label: '联系地址',
          prop: 'householdAddress',
          display: true,
          span: 24,
        },*/
      ],
    },
    {
      // icon: 'el-icon-info',
      label: '公寓信息',
      prop: 'group3',
      display: false,
      column: [
        {
          label: '床位',
          type: 'number',
          prop: 'bedCapacity',
          rules: [
            { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数,且不能为0' },
            {
              required: true,
              message: '请输入床位数',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '已用床位',
          type: 'number',
          prop: 'bedUsing',
          disabled: true,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
            {
              required: true,
              message: '请输入占用床位数',
              trigger: 'blur',
            },
          ],
        },
      ],
    },
    {
      label: '租赁信息',
      prop: 'group4',
      display: false,
      column: [
        {
          label: '总面积',
          prop: 'totalArea',
          display: true,
          rules: [
            {
              required: true,
              pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
              message: '请输入整数10位，小数2位',
            },
          ],
          placeholder: '请输入 总面积，单位m2',
          span: 8,
        },
        {
          label: '已用面积',
          prop: 'usedArea',
          display: true,
          rules: [
            {
              required: true,
              pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
              message: '请输入整数10位，小数2位',
            },
          ],
          placeholder: '请输入 已用面积，单位m2',
          span: 8,
        },
        {
          label: '可用面积',
          prop: 'availableArea',
          display: true,
          rules: [
            {
              required: true,
              pattern: /(^0$)|(^[1-9](\d{0,9})?(\.\d{0,2})?$)|(^[0-9]$)|(^\d\.[0-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/,
              message: '请输入整数10位，小数2位',
            },
          ],
          placeholder: '请输入 可用面积，单位m2',
          span: 8,
        },
      ],
    },
  ],
};
